import { render } from "./TransitionExpand.vue?vue&type=template&id=59f0b20e&scoped=true"
import script from "./TransitionExpand.vue?vue&type=script&lang=js"
export * from "./TransitionExpand.vue?vue&type=script&lang=js"

import "./TransitionExpand.vue?vue&type=style&index=0&id=59f0b20e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59f0b20e"]])

export default __exports__